import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { User } from 'oidc-client';

export type AuthState = {
    user?: User;
    error?: Error;
    loading?: boolean;
};

export const ACCESSTOKENKEY = 'ls-at-key';

const initialState: AuthState = {};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        loginStarted: state => {
            localStorage.removeItem(ACCESSTOKENKEY);
            state.loading = true;
            console.log('login started');
        },
        loginSuccess: (state, action: PayloadAction<User>) => {
            localStorage.setItem(ACCESSTOKENKEY, action.payload.access_token);
            state.user = action.payload,
            state.loading = false;
            state.error = undefined
        },
        loginFailed: (state, action: PayloadAction<Error>) => {
            state.error = action.payload,
            state.loading = false
        },
        logoutSuccess: state => {
            localStorage.removeItem(ACCESSTOKENKEY);
            state.error = undefined,
            state.loading = false,
            state.user = undefined
        },
        logoutFailed: (state, action: PayloadAction<Error>) => {
            localStorage.removeItem(ACCESSTOKENKEY);
            state.error = action.payload,
            state.loading = false
        }
    }
});

export const { loginStarted, loginSuccess, loginFailed, logoutSuccess, logoutFailed } = authSlice.actions;

export default authSlice.reducer;